(function() {
	var index = function(seg) {
		return (! seg || seg === 'filter' || /^p\d+$/.test(seg));
	};

	$.set('cdnUrl', 'https://cdn.' + $._loc.hostname.slice(4));

	$.routes.addFilter({
		index: index,
		entry: function(seg) {
			return ! index(seg);
		},
		catalog: function() {
			return $$('filters').length > 0;
		},
		product: function() {
			return $$('product').length > 0;
		}
	});

	$.routes.map({
		'$any:fire:once': 'common',
		'$root': {
			':load': 'home',
			':unload': 'home:unload'
		},
		'bathroom||kitchen': {
			'series': {
				'$index': {
					':load': 'series',
					':unload': 'series:unload'
				},
				'$slug': {
					'$index': {
						':load': 'series.entry',
						':unload': 'series.entry:unload'
					}
				}
			},
			'$/^(?!series).*$/': {
				'$catalog': {
					':load': 'catalog',
					':unload': 'catalog:unload'
				},
				'$product': {
					':load': 'product',
					':unload': 'product:unload'
				}
			}
		},
		'bathroom': {
			'faucets': {
				'creator': {
					':load': 'creator',
					':unload': 'creator:unload'
				}
			}
		},
		'products': {
			'$any': {
				':load': 'catalog',
				':unload': 'catalog:unload'
			}
		},
		'learn': {
			'$index': {
				':load': 'learn',
				':unload': 'learn:unload'
			}
		},
		'news': {
			'$index': {
				':load': 'news',
				':unload': 'news:unload'
			},
			'$slug': {
				':load': 'news.entry',
				':unload': 'news.entry:unload'
			}
		},
		'videos': {
			'$index': {
				':load': 'videos',
				':unload': 'videos:unload'
			},
			'$slug': {
				'$index': {
					':load': 'videos.entry',
					':unload': 'videos.entry:unload'
				}
			}
		},
		'showrooms': {
			'$index||canada||mexico': {
				':load': 'showrooms',
				':unload': 'showrooms:unload'
			}
		},
		'photos': {
			'$index': {
				':load': 'photos',
				':unload': 'photos:unload'
			}
		},
		'faq': {
			':load': 'faq',
			':unload': 'faq:unload'
		},
		'wishlists': {
			'$any': {
				':load': 'wishlists',
				':unload': 'wishlists:unload'
			}
		},
		'results': {
			'$index': {
				':load': 'search.results',
				':unload': 'search.results:unload'
			}
		},
		'login||register||forgot||reset': {
			'$any': {
				':load': 'auth',
				':unload': 'auth:unload'
			}
		},
		'actions': {
			'users': {
				'set-password': {
					':load': 'auth',
					':unload': 'auth:unload'
				}
			}
		},
		'dealers': {
			'login||register': {
				'$any': {
					':load': 'auth',
					':unload': 'auth:unload'
				}
			}
		},
		'$any:once:fire': 'common:setup',
		'$any:fire': 'videos:transform'
	});
})();